import http from './http'

export async function uploadFile(file) {
  const form = new FormData()
  // 传入文件名，部分后端依赖 filename 获取扩展名
  form.append('file', file, file?.name || 'file')
  // 让浏览器自动设置 multipart/form-data 的 boundary，避免服务端解析异常
  const res = await http.post('/admin/common/upload', form, { timeout: 60000 })
  // 后端可能返回字符串或包在 data 中，做兼容
  const url = typeof res.data === 'string' ? res.data : res.data?.data || res.data?.url || ''
  return url
}

export async function uploadFiles(files) {
  const list = Array.isArray(files) ? files : files ? [files] : []
  const results = []
  for (const f of list) {
    const url = await uploadFile(f)
    if (url) results.push(url)
  }
  return results
}